export const velas= [
  {
    categoria: "velas artesanales",
    nombre: "Cirio personalizado",
    imagen: require("../img/velas2.png"),
    descripcion: "Se pueden elegir desde los colores,piedras y componentes.",
    precio: "2€ ",
    Material: "Cera de abeja o soja",
    tema: ["abundancia", "amor", "protección", "ofrendas"],
  },  {
    categoria: "velas artesanales",
    nombre: "Vela personalizada",
    imagen: require("../img/prote3.png"),
    descripcion: "Se pueden elegir desde los colores,piedras y componentes. Longitud: 9cm aprox",
    precio: "6€ ",
    Material: "Cera de abeja o soja",
    tema: ["abundancia", "amor", "protección", "ofrendas"],
  },
    {
    categoria: "velas artesanales",
    nombre: "Velon gigante personalizado",
    imagen: require("../img/velonGigante.png"),
    descripcion: " Medida 16cm x 8cm aprox, tarda 2 dias en realizarse.",
    precio: "26€",
    Material: "Cera de abeja o soja",
    tema: ["abundancia", "amor", "protección", "ofrendas"],
  },
   {
    categoria: "velas artesanales",
    nombre: "Vela de protección para rituales",
    imagen: require("../img/protePiedra.png"),
    descripcion: "Se pueden elegir en negro y las piedras naturales también",
    precio: "6€",
    Material: "Cera de abeja o soja",
    tema: [ "protección"],
  },
   {
    categoria: "velas artesanales",
    nombre: "Vela deshacedor reventón",
    imagen: require("../img/volteo.png"),
    descripcion: "Solo se pueden cambiar algunos elementos visuales.⚠️Con este vela siempre con vigilancia y en un sitio aireado⚠️",
    precio: "Vela: 7€",
    Material: "Soja",
    tema: ["protección"],
  },
  {
    categoria: "velas artesanales",
    nombre: "Vela de dinero ritualizada",
    imagen: require("../img/monedas.png"),
    descripcion: "Para que llegue el dinero a tu vida.",
    precio: "7€",
    Material: "Cera de abeja",
    tema: ["abundancia"],

  },
    {
    categoria: "velas artesanales",
    nombre: "Mini vela de corazón real ritualizada",
    imagen: require("../img/velaAnatomica.png"),
    descripcion: "Para rituales de amor o ataques ",
    precio: "4€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas","muerte"],

  },    {
    categoria: "velas artesanales",
    nombre: "Velaza de corazón real ritualizada",
    imagen: require("../img/corazonAnatomicoGrande.png"),
    descripcion: "Para rituales de amor o ataques ",
    precio: "12€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas","muerte"],

  },
  {
    categoria: "velas artesanales",
    nombre: "Octavillas calaveras/corazón/huellas/calabaza mini",
    imagen: 
      require("../img/calaverasMini.png"),
    descripcion: "Para ofrendas, mini rituales o acompañamiento.",
    precio: "7€",
    Material: "Cera de abeja o soja",
    tema: ["protección", "ofrendas","muerte"],
  },
    {
    categoria: "velas artesanales",
    nombre: "Kit de velas mini",
    imagen: 
      require("../img/miniVelasTodas.png"),
    descripcion: "Para ofrendas, mini rituales o acompañamiento.",
    precio: "5€",
    Material: "Cera de abeja o soja",
    tema: ["abundancia", "amor", "protección", "ofrendas","muerte"],
  },
  {
    categoria: "velas artesanales",
    nombre: "Velón elemento Agua",
    imagen: require("../img/velonYemanja.png"),
    descripcion: "Para ofrendas, trabajar el elemento agua, trabajar con el mar.",
    precio: "9€",
    Material: "Cera de soja",
    tema: ["ofrendas"],
  },
  {
    categoria: "velas artesanales",
    nombre: "Vela pareja personalizada",
    imagen: 
      require("../img/pareja.png")
    ,
    descripcion: "Perfecta para amarres, parejas o rituales de familia y amor",
    precio: "7€",
    Material: "Cera de abeja",
    tema: ["amor", "protección", "ofrendas"],
  },
  {
    categoria:"velas artesanales",
    nombre: "Vela hombre personalizada",
    imagen: require("../img/Torso Hombre.png"),
    descripcion: "Vela personalizada con la ritualización que necesites.",
    precio: "9€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas"],
  },
    {
    categoria:"velas artesanales",
    nombre: "Vela pene personalizada",
    imagen: require("../img/peneLado.png"),
    descripcion: "Vela personalizada con la ritualización que necesites.",
    precio: "7€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas"],
  },
    {
    categoria:"velas artesanales",
    nombre: "Vela mujer personalizada",
    imagen:[require("../img/mujer.png"), require("../img/mujer2.png")],
    descripcion: "Vela personalizada con la ritualización que necesites.",
    precio: "9€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas"],
  },    {
    categoria:"velas artesanales",
    nombre: "Mini vela vulva personalizada",
    imagen:require("../img/vulva.png"),
    descripcion: "Vela personalizada con la ritualización que necesites.",
    precio: "5€",
    Material: "Cera de abeja o soja",
    tema: ["amor", "protección", "ofrendas"],
  },
  {
    categoria: "velas artesanales",
    nombre:"Vela de la abundancia ",
    imagen: require("../img/calabazaGrande.png"),
    descripcion: "Vela ritualizada para atraer la abundancia.",
    precio: "7€",
    Material: "Cera de abeja ",
    tema: ["abundancia"],
  },
    {
    categoria: "velas artesanales",
    nombre:"Vela llave artesanal ",
    imagen: require("../img/llave.png"),
    descripcion: "Vela ritualizada para abrir los caminos.",
    precio: "6€",
    Material: "Cera de abeja ",
    tema: ["abundancia"],
  },
  {
    categoria: "velas artesanales",
    nombre:"Vela de huella personalizada ",
    imagen: require("../img/Huella de perro .png"),
    descripcion: "Ofrenda de mascostas, abrecaminos o como tu lo necesites.",
    precio: "5€",
    Material: "Cera de abeja",
    tema: ["abundancia", "ofrendas"],
  },
    {
    categoria: "velas artesanales",
    nombre:"Calavera personalizada",
    imagen:[require("../img/calavera.png"), require("../img/calavera2.png")],
    descripcion: "Para ataques, protección, ofrendas o rituales de muerte.",
    precio: "9€",
    Material: "Cera de abeja o soja ",
    tema: ["protección", "ofrendas","muerte"],
  }, 
      {
    categoria: "velas artesanales",
    nombre:"serpiente personalizada",
    imagen: require("../img/serpiente.png"),
    descripcion: "Para ataques, protección, ofrendas o rituales de Mano Izquierda.",
    precio: "9€",
    Material: "Cera de abeja o soja ",
    tema: ["protección", "ofrendas","muerte"],
  },
  {
    categoria: "velas artesanales",
    nombre: "Vela altar Baphomet",
    imagen:require("../img/baphomet.png"), 
    descripcion: "Vela de ofrenda que sirve como mini altar portatil,conectar con el arquetipo o incluso amuleto. Tú decides el uso ",
    precio: "5€",
    tema: ["ofrendas","espiritualidad","satanismo"],
    Material: "Diverso"
  },
  {
    categoria: "velas artesanales",
    nombre: "Vela altar Lilith",
    imagen:[require("../img/lilith.png"),require("../img/lilithVela.png"),], 
    descripcion: "Vela de ofrenda que sirve como mini altar portatil,conectar con el arquetipo o incluso amuleto. Tú decides el uso ",
    precio: "5€",
    tema: ["ofrendas","espiritualidad","satanismo"],
    Material: "Diverso"
  },



  // 1–10
  { categoria:"velas artesanales", nombre:"Vela altar Bael", imagen:require("../img/bael.png"), descripcion:"Vela de ofrenda concebida como mini altar portátil para conexión simbólica y trabajo arquetípico.", precio:"5€", tema:["ofrendas","espiritualidad","goetia"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Agares", imagen:require("../img/agares.png"), descripcion:"Vela de ofrenda utilizada como soporte simbólico para conexión arquetípica.", precio:"5€", tema:["ofrendas","espiritualidad","goetia"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Vassago", imagen:require("../img/vassago.png"), descripcion:"Mini altar portátil orientado al trabajo introspectivo y simbólico.", precio:"5€", tema:["ofrendas","espiritualidad","goetia"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Samigina", imagen:require("../img/samigina.png"), descripcion:"Vela ritual para conexión contemplativa con el arquetipo.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","conocimiento"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Marbas", imagen:require("../img/marbas.png"), descripcion:"Vela de ofrenda simbólica asociada a procesos de transformación.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","transformacion"], material:"Diverso" },
  
  { categoria:"velas artesanales", nombre:"Vela altar Forneus", imagen:[require("../img/forneus.png"),require("../img/forneusVela.png")], descripcion:"Vela de ofrenda concebida como mini altar portátil para conexión simbólica y trabajo arquetípico.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","conocimiento"], material:"Diverso" },
  
  { categoria:"velas artesanales", nombre:"Vela altar Furfur", imagen:[require("../img/furfur.png"),require("../img/furfurVela.png")], descripcion:"Vela simbólica vinculada a la intensidad emocional.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","pasiones"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Marchosias", imagen:[require("../img/marchosias.png"),require("../img/marchosiasVela.png")], descripcion:"Mini altar simbólico asociado al valor y la firmeza.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","voluntad"], material:"Diverso" },
 
  { categoria:"velas artesanales", nombre:"Vela altar Aim", imagen:[require("../img/aim.png"),require("../img/aimVela.png")], descripcion:"Mini altar simbólico asociado a la destrucción, fuego y verdad.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","poder"], material:"Diverso" },
  { categoria:"velas artesanales", nombre:"Vela altar Goetia", imagen:require("../img/sigilosGoetia.png"), descripcion:"Vela altar a elegir de cualquier demonio.", precio:"5€", tema:["ofrendas","espiritualidad","goetia","naturaleza"], material:"Diverso" },

];
